import {Directive, EventEmitter, HostListener, Output} from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import {ProceedConfirmationComponent} from '../components/proceed-confirmation/proceed-confirmation.component';

@Directive({
  standalone: false,
  // tslint:disable-next-line:directive-selector
  selector: '[proceedConfirmation]'
})
export class ProceedConfirmationDirective {

  @Output() proceedConfirmation: EventEmitter<any> = new EventEmitter<any>();

  constructor(public dialog: MatDialog) {
  }

  @HostListener('click') onClick(): void {
    const dialogRef = this.dialog.open(ProceedConfirmationComponent, {
      width: '500px',
    });

    dialogRef.afterClosed().subscribe(confirmed => {
      if (confirmed) {
        this.proceedConfirmation.emit();
      }
    });
  }
}
